// Animation timing constants (in milliseconds)
export const ANIMATION_TIMINGS = {
  FADE_OUT: 150,
  SCALE_IN_STAGGER: 50, // 0.05s per swatch
  INITIAL_SCALE_IN_BASE: 800, // 0.8s
  INITIAL_ANIMATION_COMPLETE: 1200,
  SCALE_IN_DURATION: 400,
  TOAST_DURATION: 1400,
  TOAST_EXIT: 200,
  FORMAT_TOOLTIP_DELAY: 1000,
  FORMAT_TOOLTIP_DURATION: 3000,
};

// Color format options
export const FORMAT_OPTIONS = [
  { value: 'hex', label: 'Hex' },
  { value: 'rgb', label: 'RGB' },
  { value: 'hsb', label: 'HSB' },
  { value: 'pantone', label: 'Pantone' }
];

